import React from 'react';
import { contractOf } from '../MarketStatsBar';
import { displaySymbolOf, fmtPrice, fmtQty, fmtUsd, num, quoteFor } from './format';
import { Logo } from './PairPicker';
import './pro.css';

// "Info" tab of the chart panel: what the market is, supply, contract and
// settlement asset, from the token row the page already loaded.

const TYPE_LABEL = {
  STNTHETICS: 'SynthCrypto',
  SYNTHETICS: 'SynthCrypto',
  STABLECOIN: 'Stablecoin',
  DERIVATIVES: 'Hybrid'
};

export default function TokenInfo({ token, PecuPrice, USXMPrice }) {
  if (!token) return <div className="x-empty">Loading market info…</div>;
  const sym = displaySymbolOf(token);
  const price = num(token.currentPrice) ?? num(token.token_price);
  const supply = num(token.amount) ?? num(token.amount_issued);
  const contract = contractOf(token);
  const quote = quoteFor(token, PecuPrice, USXMPrice);
  const desc = token.description || token.token_desc || token.desc || '';
  const rows = [
    ['Pair', `${sym} / ${quote.symbol}`],
    ['Type', TYPE_LABEL[token.type] || token.type || null],
    ['Settles in', quote.symbol],
    ['Price', price !== null ? `${fmtPrice(price)} USD` : null],
    ['Price in ' + quote.symbol, price !== null && quote.price ? `${fmtQty(price / quote.price)} ${quote.symbol}` : null],
    ['Circulating supply', supply !== null ? `${fmtQty(supply)} ${sym}` : null],
    ['Market cap', supply !== null && price !== null ? fmtUsd(supply * price) : null],
    ['Issuer', token.token_issuer || token.issuer_legal_name || null],
    ['Contract', contract],
    ['Listed', token.created_at || token.createdAt ? new Date(token.created_at || token.createdAt).toLocaleDateString('en-CA') : null]
  ].filter(([, v]) => v);

  return (
    <div className="x-info">
      <div className="x-info-head">
        <Logo symbol={sym} size={40} />
        <div>
          <div className="x-info-name">{token.name || token.token_name || sym}</div>
          <div className="x-muted">{sym}</div>
        </div>
      </div>
      {desc && <p className="x-info-desc">{desc}</p>}
      <dl className="x-info-grid">
        {rows.map(([k, v]) => (
          <React.Fragment key={k}>
            <dt>{k}</dt>
            <dd className={k === 'Contract' ? 'x-mono' : undefined}>{v}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
}
